import { render, staticRenderFns } from "./homeSupervise-item.vue?vue&type=template&id=ce6cc55a&scoped=true&"
import script from "./homeSupervise-item.vue?vue&type=script&lang=js&"
export * from "./homeSupervise-item.vue?vue&type=script&lang=js&"
import style0 from "./homeSupervise-item.vue?vue&type=style&index=0&id=ce6cc55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6cc55a",
  null
  
)

export default component.exports